import {  IsNotEmpty, IsAlphanumeric, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class QcDefectRequest{
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    qcId: number;

    @ApiProperty()
    @IsOptional()
    updatedUser: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag: number;

    @ApiProperty()
    isActive: boolean;
}
export class WorkstationCoderequest{
    @ApiProperty()
    workstationCode:string;
}
export class TestNameforoperationrequest{
    @ApiProperty()
    operationId:number;
}
export class TestNameforoperationrequestQrScan{
    @ApiProperty()
    testCode:string;
}
export class workstationforOperation{
    @ApiProperty()
    operationName:string
    @ApiProperty()
    lotNumber:string;
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty()
    saleOrderItemId:number;
    @ApiProperty()
    plantId:number;
    @ApiProperty()
    subLotNumber:string;
}